import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { WjGridModule } from '@grapecity/wijmo.angular2.grid';
import { WjNavModule } from '@grapecity/wijmo.angular2.nav';
import { PlessSharedModule } from '../../../shared/pless-shared.module';
import { KYMW6800Component } from './kymw6800.component';
import { KYMW6801Module } from '../kymw6801/kymw6801.module';
import { KYMW6802Module } from '../kymw6802/kymw6802.module';
import { WjInputModule } from '@grapecity/wijmo.angular2.input';
import { WjChartModule } from '@grapecity/wijmo.angular2.chart';

import { AppCommonsModule } from '../../../commons/app-commons.module';
import { GetCategoryInfoService } from './api-services/get-category-info.service';
import { GetCategoryConvListService } from './api-services/get-category-conv-list.service';
/**
 * ECカテゴリ変換マスタ一覧画面 モジュール設定クラス
 *
 * @export KYMW6800Module
 * @class KYMW6800Module
 */
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    PlessSharedModule,
    WjGridModule,
    WjNavModule,
    KYMW6801Module,
    KYMW6802Module,
    WjInputModule,
    WjChartModule,
    AppCommonsModule,
  ],
  declarations: [
    KYMW6800Component,
  ],
  providers: [
    GetCategoryInfoService,
    GetCategoryConvListService,
  ],
})
export class KYMW6800Module {

}
